import React, {useMemo} from "react";

import TemplateEditor from "../../../Templates/TemplateEditor";
import useDialog from "../../../../hooks/useDialog";
import {useGlobalState} from "../../../../GlobalState";

import {
    Button,
    Collapse,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography
} from "@mui/material";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CloseIcon from '@mui/icons-material/Close';
import Stack from "@mui/material/Stack";
import {addDays, formatISO, startOfToday} from "date-fns";


const QuoteTemplate = () => {
    const helpDialogManager = useDialog();
    const {logo} = useGlobalState();
    const today = startOfToday();
    const dateRepresentation =  {representation: 'date' };

    const quoteTemplateVariables = useMemo(
        () => ({
            locale: "IT",
            quote: {
                title: "Nome Struttura",
                logo_url: logo,
                code_number: "123456789",
                name: "Nome Ospite",
                surname: "Cognome Ospite",
                email: "email.ospite@mail.com",
                adults: 2,
                children: 1,
                pets_number: 0,
                expiration: formatISO(addDays(today, 2), dateRepresentation),
                quote_variants: [{
                    quote_items: [{
                        arrival: formatISO(addDays(today, 14), dateRepresentation),
                        departure: formatISO(addDays(today, 21), dateRepresentation),
                        price_cent: 99999,
                        apartment_name: "Nome appartamento",
                        apartment_description: "Descrizione dell'appartamento",
                        apartment_url: "#",
                        mq: 75,
                        rooms: 3,
                        number_of_bathroom: 2,
                        photos: [
                            "/img/quote/livingroom.jpg",
                            "/img/quote/bedroom.jpg",
                            "/img/quote/bathroom.jpg"
                        ]
                    }]
                }],
                booking_condition: {
                    confirmation_policy: "deposit",
                    deposit_percentage: 30,
                    cancellation_policy: "time_restricted_refundable",
                    refundable_until: formatISO(addDays(today, 7), dateRepresentation),
                    payment_policy: "host_customized",
                    tourist_tax_policy: "excluded",
                    tourist_tax_unit_price_cent: 150
                }
            }
        }),
        [logo]  // eslint-disable-line react-hooks/exhaustive-deps
    )

    return <Container maxWidth="md" disableGutters={true} sx={{pt: 3}}>
        <TemplateEditor type="Templates::QuoteTemplate"
                        templateVariables={quoteTemplateVariables}
                        alertElement={
                            <TransitionAlert severity="info">
                                Le immagini e alcune informazioni nel modello email sono a scopo dimostrativo.
                                <Button size="small" onClick={helpDialogManager.open}>Scopri come
                                    personalizzarlo</Button>
                            </TransitionAlert>
                        }
        />
        {
            helpDialogManager.show && <HelpDialog handleClose={helpDialogManager.close}/>
        }
    </Container>
}

const TransitionAlert = (props) => {
    const {children, ...alertProps} = props;
    const [open, setOpen] = React.useState(true);

    return (
        <Box sx={{width: '100%'}}>
            <Collapse in={open}>
                <Alert {...alertProps}
                       action={
                           <IconButton
                               aria-label="close"
                               color="inherit"
                               size="small"
                               onClick={() => {
                                   setOpen(false);
                               }}
                           >
                               <CloseIcon fontSize="inherit"/>
                           </IconButton>
                       }
                       sx={{mb: 2}}
                >
                    {children}
                </Alert>
            </Collapse>
        </Box>
    )
}

const HelpDialog = ({handleClose}) => {
    return <Dialog
        open={true}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <DialogTitle id="alert-dialog-title">
            Modelli email per preventivi
        </DialogTitle>

        <DialogContent>
            <Stack spacing={2}>
                <Typography>
                    Le informazioni di un preventivo <b>visualizzate nel modello email</b>, tra cui la data di arrivo,
                    la data di partenza
                    il nome dell'ospite, le condizioni di prenotazione, le informazioni e le immagini delle strutture
                    sono a solo scopo dimostrativo.
                </Typography>
                <Typography>
                    Queste informazioni verranno sostituite con quelle reali quando verrà creato un preventivo.
                </Typography>
                <Typography>
                    <b>I modelli email possono essere personalizzati</b> sia attivando la modalità di modifica
                    con l'apposito interruttore, in questo modo si potranno modificare i blocchi evidenziati,
                    sia modificando le descrizioni e le foto delle tue strutture accedendo al menu dell'applicazione
                    nella sezione "strutture".
                </Typography>
            </Stack>
        </DialogContent>

        <DialogActions>
            <Button onClick={handleClose} autoFocus>
                Ok
            </Button>
        </DialogActions>
    </Dialog>
}

export default QuoteTemplate;

